import { styles, sectionBadgeRecipe, SectionBadgeVariants } from "./SectionBadge.style";
import { cx } from "../../../styled-system/css";

interface SectionBadgeProps {
  text: string;
  variant: SectionBadgeVariants;
  imageUrl?: string;
  imageAltText?: string;
}

export const SectionBadge = (props: SectionBadgeProps) => {
  const { text, variant, imageUrl, imageAltText } = props;
  return (
    <div className={cx(sectionBadgeRecipe({ variant }), styles.root())}>
      <span className={styles.text()}>{text}</span>
      {imageUrl && <img src={imageUrl} className={styles.image()} alt={imageAltText || ""} />}
    </div>
  );
};

SectionBadge.displayName = "SectionBadge";
